function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.8784 8.81767C29.755 8.93917 29.593 9 29.4312 9C29.2698 9 29.1085 8.93964 28.9851 8.81876C28.7382 8.57669 28.7377 8.18379 28.984 7.9411L31.846 5.12068L0.753651 5.12069C0.404861 5.12069 0.12207 4.84278 0.12207 4.5C0.12207 4.15722 0.404861 3.87931 0.753651 3.87931L31.846 3.8793L28.984 1.05904C28.7377 0.816345 28.7382 0.423292 28.9851 0.181223C29.2321 -0.0608465 29.632 -0.060381 29.8784 0.182464L33.8152 4.06178C34.061 4.30401 34.061 4.69597 33.8152 4.93835L29.8784 8.81767Z",
  fill: "#111111"
});

var SvgArrowThinRight = function SvgArrowThinRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 34,
    height: 9,
    viewBox: "0 0 34 9",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArrowThinRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-thin-right.92c92263.svg";
export { ForwardRef as ReactComponent };